import {
    HttpResponse,
    WorkplaceShutdownModel,
    QueryModel,
    RequestParams,
    WorkplaceShutdownModelIEnumerableApiResultSuccess,
    WorkplaceShutdownModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class WorkplaceShutdownsDataService implements CrudService<WorkplaceShutdownModel, WorkplaceShutdownModel> {
    getAll(query: CrudDataQuery<WorkplaceShutdownModel>): Promise<CrudEnumerableResponse<WorkplaceShutdownModel>> {
        return ApiService.api.getWorkplaceShutdownBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<WorkplaceShutdownModel>): Promise<CrudEnumerableResponse<WorkplaceShutdownModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<WorkplaceShutdownModel>> {
        return ApiService.api.getWorkplaceShutdownById(id, params);
    }

    create(item: WorkplaceShutdownModel, params?: RequestParams): Promise<CrudResponse<WorkplaceShutdownModel>> {
        return ApiService.api.insertWorkplaceShutdown(item, params);
    }

    update(item: WorkplaceShutdownModel, params?: RequestParams): Promise<WorkplaceShutdownModel> {
        return ApiService.api.updateWorkplaceShutdown(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<WorkplaceShutdownModel> {
        return ApiService.api.patchWorkplaceShutdown(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<WorkplaceShutdownModel>): Promise<CrudEnumerableResponse<WorkplaceShutdownModel>> {
        return ApiService.api.deleteWorkplaceShutdowns(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationWorkplaceShutdown(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<WorkplaceShutdownModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: WorkplaceShutdownModel, params?: RequestParams): Promise<CrudResponse<WorkplaceShutdownModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getWorkplaceShutdownGroupped(query, params);
    }

}
